import { Outlet } from 'react-router-dom';

export default function VendorLayout() {
  return <Outlet />;
}